import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import filterSlice from "../redux/reducer/filter.reducer";
import demandSlice from "../redux/reducer/demandfilter.reducer";
import { homeApi } from "../../services/redux/api/homeApi";
import { forecastApi } from "./api/forecastApi";
import { inventoryApi } from "./api/inventoryApi";
import { demandApi } from "./api/demandApi";
import { deepDiveApi } from "./api/deepdive";
import { featureImportanceApi } from "./api/featureImportanceApi";
import { consensusApi } from "./api/consensus";
import { forecastSegmentationApi } from "./api/forecastSegmentationApi";
import { inventoryProjectionApi } from "./api/inventorySoq";
import { onHandSoqApi } from "./api/onHandSoqApi";
import { cannibalizationAPI } from "./api/cannibalization";
import { posVsShippedApi } from "./api/posVsShippedApi";
import { adEffectivenessApi } from "./api/adEffectiveness";
import { accuracyDeepDiveApi } from "./api/accuracyDeepDive";
import { InventoryOverviewApi } from "./api/inventoryOverview";

const rootReducer = combineReducers({
  filter: filterSlice.reducer,
  dbfilter: demandSlice.reducer,
  [homeApi.reducerPath]: homeApi.reducer,
  [forecastApi.reducerPath]: forecastApi.reducer,
  [inventoryApi.reducerPath]: inventoryApi.reducer,
  [demandApi.reducerPath]: demandApi.reducer,
  [deepDiveApi.reducerPath]: deepDiveApi.reducer,
  [featureImportanceApi.reducerPath]: featureImportanceApi.reducer,
  [consensusApi.reducerPath]: consensusApi.reducer,
  [forecastSegmentationApi.reducerPath]: forecastSegmentationApi.reducer,
  [inventoryProjectionApi.reducerPath]: inventoryProjectionApi.reducer,
  [onHandSoqApi.reducerPath]: onHandSoqApi.reducer,
  [cannibalizationAPI.reducerPath]: cannibalizationAPI.reducer,
  [posVsShippedApi.reducerPath]: posVsShippedApi.reducer,
  [adEffectivenessApi.reducerPath]: adEffectivenessApi.reducer,
  [accuracyDeepDiveApi.reducerPath]: accuracyDeepDiveApi.reducer,
  [InventoryOverviewApi.reducerPath]: InventoryOverviewApi.reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      homeApi.middleware,
      forecastApi.middleware,
      inventoryApi.middleware,
      demandApi.middleware,
      deepDiveApi.middleware,
      featureImportanceApi.middleware,
      consensusApi.middleware,
      forecastSegmentationApi.middleware,
      inventoryProjectionApi.middleware,
      onHandSoqApi.middleware,
      cannibalizationAPI.middleware,
      posVsShippedApi.middleware,
      adEffectivenessApi.middleware,
      accuracyDeepDiveApi.middleware,
      InventoryOverviewApi.middleware
    ),
});

setupListeners(store.dispatch);
export default store;
